import React, { useState } from 'react';
import { PInputText, PInputTextProps } from 'components/prime/PInputText/PInputText';
import { PasswordInputStyle as S } from './PasswordInput.style';
import { PButtonIcon } from 'components/prime/PButton/PButtonIcon';

export const PasswordInput = React.forwardRef<typeof PInputText, PInputTextProps>((props, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <S.InputText
      autoComplete="off"
      {...props}
      type={showPassword ? 'text' : 'password'}
      rightIcon={
        !!props.value ? (
          <PButtonIcon
            size="xs"
            shape="squircle"
            icon={!showPassword ? 'eyeLine' : 'eyeOffLine'}
            onClick={() => setShowPassword(!showPassword)}
            disabled={props.disabled}
          />
        ) : null
      }
      ref={ref as any}
    />
  );
});
